export default {
	videoPath: 'lodgestore/elvita/oi/videos/head',
	filePath: 'lodgestore/elvita/oi/',
	storageUrl: import.meta.env.VITE_STORAGE_URL,
	gaKey: import.meta.env.VITE_GA_KEY,
	searchUrl: import.meta.env.VITE_SEARCH_URL,
	implementation: import.meta.env.VITE_IMPLEMENTATION,
	contentVersion: import.meta.env.VITE_CONTENT_VERSION,
	imagesCdnUrl: import.meta.env.VITE_IMAGES_CDN_URL,
};
